<template>
  <div>
    <div v-if="subscriptionPending" class="text-center">
      <AppLoader></AppLoader>
    </div>
    <template v-else-if="hasDataroomStoragePlan || canCreateDataroomPayPerUse || isLpOnlyWithoutDataroom">
      <app-title-bar>
        <app-material-icon :name="ROOM_ICONS.dataroom.name" :color="ROOM_ICONS.dataroom.color" filled />
        <h2 class="heading-xs-bold text-text-primary">{{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}</h2>
      </app-title-bar>

      <!-- Forfait (dataroom storage plan) -->
      <div v-if="hasDataroomStoragePlan" class="d-flex flex-column row-gap-4 layout-spacing">
        <div class="SubscriptionConsumption__frames d-flex flex-column flex-md-row column-gap-4 row-gap-4">
          <SubscriptionConsumptionDrPlan class="SubscriptionConsumption__frame"/>
          <SubscriptionConsumptionSupport class="SubscriptionConsumption__frame"/>
        </div>

        <div>
          <div class="SubscriptionConsumption__tab-header">
            <SubscriptionConsumptionTabs
              v-model="currentTab"
              :tabs="tabs"
              data-locator="subscription-consumption-tabs"
            />
          </div>

          <v-window v-model="currentTab" class="mt-4">
            <v-window-item value="usage" eager>
              <SubscriptionConsumptionDrPlanUsage/>
            </v-window-item>

            <v-window-item value="history" eager>
              <SubscriptionConsumptionDrPlanHistory/>
            </v-window-item>
          </v-window>
        </div>
      </div>

      <!-- Datarooms Pay-per-use -->
      <div v-else-if="canCreateDataroomPayPerUse" class="d-flex flex-column row-gap-4 layout-spacing">
        <div class="SubscriptionConsumption__frames d-flex flex-column flex-md-row column-gap-4 row-gap-4">
          <SubscriptionConsumptionDrPpu class="SubscriptionConsumption__frame"/>
          <SubscriptionConsumptionSupport class="SubscriptionConsumption__frame"/>
        </div>

        <div>
          <div class="SubscriptionConsumption__tab-header">
            <SubscriptionConsumptionTabs
              v-model="currentTab"
              :tabs="tabs"
              data-locator="subscription-consumption-pay-per-use-tabs"
            />
            <SearchTextField v-model="payPerUseSearch" class="mb-2"/>
          </div>

          <v-window v-model="currentTab" class="mt-4">
            <v-window-item value="usage" eager>
              <SubscriptionConsumptionDrPpuUsage :search="payPerUseSearch"/>
            </v-window-item>

            <v-window-item value="history" eager>
              <SubscriptionConsumptionDrPpuHistory :search="payPerUseSearch"/>
            </v-window-item>
          </v-window>
        </div>
      </div>

      <!-- LP-only incentive empty state -->
      <div v-else class="layout-spacing">
        <SubscriptionConsumptionEmptyState/>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  import AppLoader from '@/common/AppLoader.vue'
  import SearchTextField from '@/common/SearchTextField.vue'
  import { ROOM_ICONS } from '@/common/utils/rooms'

  import SubscriptionConsumptionDrPlan from './SubscriptionConsumptionDrPlan.vue'
  import SubscriptionConsumptionDrPlanHistory from './SubscriptionConsumptionDrPlanHistory.vue'
  import SubscriptionConsumptionDrPlanUsage from './SubscriptionConsumptionDrPlanUsage.vue'
  import SubscriptionConsumptionDrPpu from './SubscriptionConsumptionDrPpu.vue'
  import SubscriptionConsumptionDrPpuHistory from './SubscriptionConsumptionDrPpuHistory.vue'
  import SubscriptionConsumptionDrPpuUsage from './SubscriptionConsumptionDrPpuUsage.vue'
  import SubscriptionConsumptionEmptyState from './SubscriptionConsumptionEmptyState.vue'
  import SubscriptionConsumptionSupport from './SubscriptionConsumptionSupport.vue'
  import SubscriptionConsumptionTabs from './SubscriptionConsumptionTabs.vue'

  const TRANSLATION_KEY_PREFIX = 'subscriptions.views.SubscriptionConsumption'

  export default {
    name: 'SubscriptionConsumption',
    components: {
      AppLoader,
      SearchTextField,
      SubscriptionConsumptionDrPlanUsage,
      SubscriptionConsumptionDrPpuUsage,
      SubscriptionConsumptionDrPpuHistory,
      SubscriptionConsumptionEmptyState,
      SubscriptionConsumptionDrPlanHistory,
      SubscriptionConsumptionDrPpu,
      SubscriptionConsumptionDrPlan,
      SubscriptionConsumptionSupport,
      SubscriptionConsumptionTabs,
    },
    data () {
      return {
        TRANSLATION_KEY_PREFIX,
        ROOM_ICONS,
        currentTab: 'usage',
        payPerUseSearch: '',
        tabs: [
          { id: 'usage', labelKey: `${TRANSLATION_KEY_PREFIX}.tabs.usage` },
          { id: 'history', labelKey: `${TRANSLATION_KEY_PREFIX}.tabs.history` },
        ],
      }
    },
    computed: {
      ...mapGetters('subscription', ['hasDataroomStoragePlan']),
      ...mapGetters('user', ['canCreateDataroomPayPerUse', 'isLpOnlyWithoutDataroom']),
      ...mapState('subscription', ['subscription', 'subscriptionPending']),
    },
  }
</script>

<style scoped lang="scss">
  .SubscriptionConsumption__frame {
    flex: 1 1 0;
    min-width: 0;
  }

  .SubscriptionConsumption__tab-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid rgb(var(--v-theme-border-primary));
  }
</style>
